import React, { useCallback, useEffect, useState } from 'react'
import RangeSlider from '../forms/RangeSlider'
import InfoTag from '../InfoTag'

const MaxSlider = ({keyName, title, min, max, handleParams, params, step, formatter, unit, description }) => {
    // { min, max, current, callback, step, valueFormatter, unit, children, className, type }

    const [current, setCurrent] = useState(null)

    const handleCallback = useCallback( (value) => {
        const newParams = new URLSearchParams( params.toString() )
        newParams.set(`${keyName}`, value);

        if (value >= max) { newParams.delete(`${keyName}`) }

        handleParams(newParams)

    },[handleParams, params, max, keyName])

	const formatterCaller = useCallback((value) => {
		if(!value || value === '') { return '' }

		if( typeof formatter === "function") {
			return formatter(value)
		} 
		return value
	},[formatter])

    useEffect(()=>{
        let newValue;

        if(params.get(`${keyName}`) !== null && params.get(`${keyName}`) !== current) {
			newValue = Math.min(params.get(`${keyName}`),max)
 		} else {
             newValue = max
        }
        setCurrent(newValue)
    },[params, max])

    return (
        <div className="multiselect-container">
            <label>{ title }</label>
            <div className="maxrange-wrapper">
                <RangeSlider
                    min={min}
                    max={max}
                    current={current}
                    callback={handleCallback}
                    step={step}
                    valueFormatter={formatterCaller}
                    unit={unit}
                    // children={children}
                    // className={className}
                    // type={type}
                >
                </RangeSlider>
                <span className="desc">{ description}</span>
            </div>
        </div>
    )
}

export default MaxSlider